module.exports = __webpack_public_path__ + "img/banner.627ae3cb.png";